<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
    import type { PricingElementEntity } from './pricing-element.entity'
    import { onMount } from 'svelte'
    import { months } from 'dayjs'

    let coupon: string = null
    let couponed = null
    let total = 0
    let subtotal = 0
    export let plan: PricingElementEntity

    function updateTotal() {
        subtotal = (plan[couponed] ?? plan.price) * plan.months
        let price = plan[couponed] ?? plan.price
        for (const extra of plan.extras) {
            if (extra.checked) {
                price += extra[couponed] ?? extra.price
            }
        }
        total = price * plan.months
    }

    function evaluateCoupon() {
        couponed = plan.coupons.find((el) => el.toLowerCase() === coupon.toLowerCase())
        plan = plan
        updateTotal()
        if (!couponed) {
            window.alert('Este cupom é inválido ou expirou.')
        }
    }

    onMount(() => {
        console.log('plan', plan)
        updateTotal()
    })

    function openLink(link) {
        // chamar o servidor para gerar o link e abrir para pagamento
    }
</script>

<div class="plan">
    <div class="plan_title">
        <span>{plan.title}</span>
    </div>
    <div class="plan_items">
        {#each plan.items as item}
            <div class="plan_item">
                {#if item.checked}
                    <Fa icon={faCheckCircle}></Fa>
                {:else}
                    <Fa icon={faTimesCircle}></Fa>
                {/if}
                <span>{item.title}</span>
            </div>
        {/each}
    </div>
    <div class="plan_partial">
        <div>Subtotal</div>
        <div>{subtotal.toFixed(2)}</div>
    </div>
    <div class="plan_extras">
        {#each plan.extras as extra, index}
            <div class="plan_extra">
                <div class="form-check form-switch">
                    <input
                        class="form-check-input"
                        bind:checked={extra.checked}
                        type="checkbox"
                        role="switch"
                        id="extra_{index}"
                        on:change={updateTotal}
                    />
                    <label class="form-check-label" for="extra_{index}">{extra.title}</label>
                </div>
                <div>{((extra[couponed] ?? extra.price) * plan.months).toFixed(2)}</div>
            </div>
        {/each}
    </div>
    <div class="plan_coupon">
        <label for="">Possuo um cupom</label>
        <div class="input-group input-group-sm">
            <input type="text" bind:value={coupon} />
            <button on:click={evaluateCoupon}>Ok</button>
        </div>
    </div>
    <div class="plan_total">
        <div class="plan_total_price">
            <div>Valor Final</div>
            <div>{total.toFixed(2)}</div>
        </div>
        <div class="plan_total_conditions">
            {#if plan.months > 1}
                <div>Divida em {plan.installments} de {(total / plan.installments).toFixed(2)} no cartão sem juros</div>
            {/if}
            <div>
                {plan.conditions}
            </div>
        </div>
    </div>
    <div class="plan_act">
        <button on:click={() => openLink(plan.planId)} class="btn btn-secondary">Selecionar</button>
    </div>
</div>

<style>
</style>
